import { ZfBanner } from '@zafire/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ZfDividerTitle } from '../../../../../components/common/ZfDividerTitle';
import { RootState } from '../../../../../store';
import { redirectToBrServicingRolesTab } from '../../../../../utils/browserUtils';

type Props = { product: 'wealthplanning' | 'activeReferralWp' };

export const ExternalServicingUsersConfigurationSection: React.FC<Props> = ({ product }) => {
  const { t } = useTranslation();
  const CLM_URL = useSelector((state: RootState) => state.appConfig.CLM_URL);
  const productTestId = product === 'wealthplanning' ? 'wealth-planning' : 'active-referral-wp';
  const translationPrefix = `pb.configureproductmodal.${product}.configuration`;

  return (
    <div data-testid={`${productTestId}-configuration-section`}>
      <ZfDividerTitle label={t(`${translationPrefix}.title`)} />
      <ZfBanner
        type="warning"
        description={t(`${translationPrefix}.description`)}
        actionButtonText={t(`${translationPrefix}.action`)}
        onBannerActionButtonClick={() => redirectToBrServicingRolesTab(CLM_URL)}
        data-testid={`${productTestId}-servicing-users-banner`}
      />
    </div>
  );
};
